import React from "react";
import { useTranslation } from "react-i18next";

/** The six checks as traffic lights: green when met, amber with what to do when not. */
export default function CopyChecklist({ items }) {
  const { t } = useTranslation();
  const done = items.filter((item) => item.ok).length;
  return (
    <div className="lp-check" aria-label={t("SEO checklist")}>
      <p className="lp-check__title">
        {t("Ready for Google")} <span className="lp-check__score">{done}/{items.length}</span>
      </p>
      <ul className="lp-check__list">
        {items.map((item) => (
          <li key={item.key} className={`lp-check__item${item.ok ? " is-ok" : ""}`}>
            <span className="lp-check__dot" aria-hidden="true" />
            <span>
              {t(item.label)}
              {!item.ok && <span className="lp-check__advice"> {item.advice}</span>}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
